import ReactGA from "react-ga4";
import AppRoutes from "./screens/routes";
import { useTheme } from "./shared/hooks/useTheme";
import "./shared/oversight-core/bootstrap/bootstrap.scss";
ReactGA.initialize("G-TWHCJ9L65L");

function App() {
  useTheme();
  return <AppRoutes />;
}

export default App;
